import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(tz);

let _facilityTz = "America/Chicago";

export function setFacilityTimezone(timezone: string) {
  _facilityTz = timezone;
}

export function getFacilityTimezone(): string {
  return _facilityTz;
}

/** Format a UTC ISO string as a date in facility timezone. */
export function formatDate(iso: string, fmt = "MM/DD/YYYY"): string {
  return dayjs.utc(iso).tz(_facilityTz).format(fmt);
}

/** Format a UTC ISO string as a date+time in facility timezone. */
export function formatDateTime(iso: string, fmt = "MM/DD/YYYY h:mm A"): string {
  return dayjs.utc(iso).tz(_facilityTz).format(fmt);
}

/** Format a UTC ISO string as a short date+time in facility timezone. */
export function formatShortDateTime(iso: string, fmt = "M/D h:mm A"): string {
  return dayjs.utc(iso).tz(_facilityTz).format(fmt);
}

/**
 * Convert a dayjs value from a DatePicker (browser-local) to a UTC ISO string
 * interpreted as facility-local time.  Ensures "3:00 PM" always means
 * "3:00 PM facility time" regardless of the user's browser timezone.
 */
export function toFacilityUTC(d: dayjs.Dayjs): string {
  return dayjs.tz(d.format("YYYY-MM-DD HH:mm:ss"), _facilityTz).utc().toISOString();
}
